import { BaseIntegration, ServiceDetailViewModel } from "@payping/api";
import { LOGGED_OUT } from "./constants";
import { LoggedOutAction } from "./types";

export const SET_SERVICE_LIST = "SET_SERVICE_LIST";
export const SET_ONE_SERVICE = "SET_ONE_SERVICE";

export interface ServiceState {
  oneService: BaseIntegration;
  list: ServiceDetailViewModel[];
  totalCount: number;
}

export interface SetServiceListAction {
  type: typeof SET_SERVICE_LIST;
  payload: { list: ServiceDetailViewModel[]; totalCount: number };
}

export interface SetOneServiceAction {
  type: typeof SET_ONE_SERVICE;
  payload: BaseIntegration;
}

export type ServiceActionTypes = SetServiceListAction | SetOneServiceAction | LoggedOutAction;

const initialState: ServiceState = {
  list: [],
  oneService: {},
  totalCount: 0,
};

export default function services(state = initialState, action: ServiceActionTypes): ServiceState {
  if (action.type === SET_SERVICE_LIST) {
    const { list, totalCount } = action.payload;
    return {
      ...state,
      list,
      totalCount,
    };
  }

  if (action.type === SET_ONE_SERVICE) {
    return { ...state, oneService: { ...action.payload } };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
